if (!customElements.get('masonry-slider')) {
  class MasonrySlider extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleIndexChange(index) {
      if (!this.slider) return;

      this.slider.slideTo(index - 1, 0, null);
    }

    handleToggle(event) {
      if (this.getAttribute('data-id') != event.detail.id) return;

      this.classList.toggle('is-open');
      toggleLock(this.classList.contains('is-open'), this);

      if (event.detail.index) this.handleIndexChange(event.detail.index);
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          768: {},
        },
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }

    disconnectedCallback() {
      document.removeEventListener('exo:masonry-toggle', this.handleToggleRef);
    }

    connectedCallback() {
      document.addEventListener('exo:masonry-toggle', this.handleToggleRef);

      this.initSlider();
    }
  }

  customElements.define('masonry-slider', MasonrySlider);
}
